import { writable, derived } from 'svelte/store';

// Create the undo store for tracking undo/redo availability
function createUndoStore() {
    const { subscribe, set: _set, update } = writable({
        claims: {
            canUndo: false,
            canRedo: false,
            undoCount: 0,
            redoCount: 0
        },
        spec: {
            canUndo: false,
            canRedo: false,
            undoCount: 0,
            redoCount: 0
        }
    });

    return {
        subscribe,
        updateClaimsUndoState: (canUndo, canRedo, undoCount = 0, redoCount = 0) => {
            update(state => ({
                ...state,
                claims: { canUndo, canRedo, undoCount, redoCount }
            }));
        },
        updateSpecUndoState: (canUndo, canRedo, undoCount = 0, redoCount = 0) => {
            update(state => ({
                ...state,
                spec: { canUndo, canRedo, undoCount, redoCount }
            }));
        }
    };
}

export const undoStore = createUndoStore();

// Derived stores for easy access
export const claimsUndoState = derived(undoStore, $undoStore => $undoStore.claims);
export const specUndoState = derived(undoStore, $undoStore => $undoStore.spec);